import script from "./CreatorPlanLimitPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorPlanLimitPrompt.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__